import { render } from "./QrPage.vue?vue&type=template&id=268f1c53&scoped=true"
import script from "./QrPage.vue?vue&type=script&lang=js"
export * from "./QrPage.vue?vue&type=script&lang=js"

import "./QrPage.vue?vue&type=style&index=0&id=268f1c53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268f1c53"]])

export default __exports__